import { useState } from "react";
import { Button, FormControl, MenuItem, SelectChangeEvent, Stack } from "@mui/material";
import StyledSelect from "../common/StyledSelect";
import MultiResourceDialogSelect from "./MultiResourceDialogSelect";

interface ResourceSelected {
  Arn: string;
  ResourceType: string;
  Region: string;
  OwningAccountId: string;
}

const MultiResourceSelect = ({
	selectedRows,
	rows,
  setStep3Unlock,
  selectedResources,
  changeTab
}: any) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

	const handleConfirm = (resources: ResourceSelected[]) => {
    selectedResources(resources);
    setStep3Unlock(true);
		changeTab(2);
		setOpen(false);
  };

  return (
    <Stack
      direction="row"
      spacing={2}
    >
      <Button 
        disabled={Object.keys(selectedRows).length === 0} 
        onClick={() => handleClickOpen()} 
        type="submit" 
        variant="contained"
        sx={{
            width:  160,
            height: 40,
            bgcolor: "secondary.main",
            "&:hover": {
                bgcolor:"secondary.main",
                color: "secondary.contrastText"
            }
        }}
      >
        Tag Resources
      </Button>
			<MultiResourceDialogSelect
				open={open}
				rows={rows}
				handleClose={handleClose}
				handleConfirm={handleConfirm}
			></MultiResourceDialogSelect>
    </Stack>
  );
};

export default MultiResourceSelect;
